import _get from 'lodash/get';

export const BREAKPOINTS = {
    SMALL_BP: 0,
    MEDIUM_BP: 768,
    LARGE_BP: 1024,
    XL_BP: 1304,
};

export const breakPointsName = {
    small: 'SMALL_BP',
    medium: 'MEDIUM_BP',
    large: 'LARGE_BP',
    xl: 'XL_BP',
};

const DEFAULT_ITEMS_PER_BP = 6;

/**
 * @description Provide a list of items to show
 * @param {array} list A list to be paginated
 * @param {integer} numberOfPages The number of pages you want to include into the paginatedList
 * @param {object} itemsPerPageData A map between breakpoints and the page size
 * @returns {object}  A paginatedList, a boolean indicating if there is more items to paginate, a string to indicate the breakpoint currently used
 */
export const getPaginatedList = (list, numberOfPages, itemsPerPageData, width = 0) => {

    const breakpointsNAmeKeysArray = Object.keys(breakPointsName);

    const selectedBreakpointNameKey = breakpointsNAmeKeysArray
        .filter((breakpointNameKey) => {

            return BREAKPOINTS[breakPointsName[breakpointNameKey]] <= width;

        })
        .reduce((candidateBreakpointNameKey, currentBreakpointNameKey) => {

            const candidateBreakpointValue = BREAKPOINTS[breakPointsName[candidateBreakpointNameKey]];
            const currentBreakpointValue = BREAKPOINTS[breakPointsName[currentBreakpointNameKey]];

            const majorBreakPointValue = Math.max(candidateBreakpointValue, currentBreakpointValue);

            return currentBreakpointValue === majorBreakPointValue
                ? currentBreakpointNameKey
                : candidateBreakpointNameKey;

        });

    const selectedBreakpoint = breakPointsName[selectedBreakpointNameKey];
    const itemsPerPage = _get(itemsPerPageData, selectedBreakpoint, DEFAULT_ITEMS_PER_BP);
    const paginatedList = list.slice(
        0,
        itemsPerPage * numberOfPages
    );

    const moreItemsToPaginate = paginatedList.length !== list.length;

    return {
        paginatedList,
        moreItemsToPaginate,
        selectedBreakpoint,
    };

};

/**
 * @description It gives the first page item index, from the second page onward
 * @param {integer} pageSize
 * @param {integer} listSize
 * @returns {integer|null} The item index or null if you are in the list's first page
 */
export const getFocusOnPageFirstItem = (pageSize, listSize) => {

    const isMoreThanOnePage = listSize > pageSize;
    const isLastPagesComplete = listSize % pageSize === 0;

    const focusIndex  = !isMoreThanOnePage
        ? null
        : isLastPagesComplete
            ? listSize - pageSize
            : Math.floor(listSize / pageSize) * pageSize;

    return focusIndex;

};
